import { useEffect, useState } from "react";
import { Clock3, Lock, Truck, FileCheck2, Briefcase, HandHelping } from "lucide-react";

const items = [
  { icon: Clock3, label: "Intervention rapide 24/48h" },
  { icon: Lock, label: "Documents confidentiels" },
  { icon: Truck, label: "Transport sécurisé" },
  { icon: FileCheck2, label: "Certificat destruction" },
  { icon: Briefcase, label: "Service réservé aux professionnels" },
  { icon: HandHelping, label: "Manutention complète" },
];

const ROTATE_MS = 4000;

export default function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % items.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, [paused]);

  const Active = items[index].icon;

  return (
    <div
      className="relative z-30 bg-slate-950 text-white overflow-hidden"
      data-testid="announcement-bar"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 md:h-10 flex items-center justify-center gap-4">
        {/* Rotating message */}
        <div
          key={index}
          className="flex items-center gap-2 sm:gap-2.5 animate-fade-in-up"
          data-testid={`announcement-item-${index}`}
          aria-live="polite"
        >
          <Active className="h-3.5 w-3.5 text-emerald-400 shrink-0" strokeWidth={1.75} />
          <span className="text-[11px] sm:text-xs font-bold tracking-wide whitespace-nowrap">
            {items[index].label}
          </span>
        </div>

        {/* Progress dots */}
        <div className="hidden sm:flex items-center gap-1.5 ml-3" aria-hidden="true">
          {items.map((_, i) => (
            <span
              key={i}
              className={`h-1 rounded-full transition-all duration-500 ${
                i === index ? "w-4 bg-emerald-400" : "w-1 bg-white/25"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
